module.exports = __webpack_public_path__ + "static/media/logoPub.37507e38.svg";